<template>
  <div class="chart">
    <div :id="report.id" :style="{width: report.width, height: report.height}"></div>
  </div>
</template>

<script>
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
export default {
  name: "ColumnChart",
  props: {
    report: {
      type: Array | Object,
      default() {
        return {};
      }
    },
  },
  data(){
    return{

    }
  },
  mounted() {
    this.drawLine()
  },
  methods:{
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById(this.report.id))
      // 绘制图表
      myChart.setOption({
        title: { text: this.report.name },
        tooltip: {},
        xAxis: {
          data: this.report.types
        },
        yAxis: {},
        series:this.report.data
      });
    }
  }
}
</script>

<style scoped lang="scss">
  .chart{
    background: #ffffff;
    margin-right: 10px;
    padding-top: 10px;
    border-radius: 8px;
  }
</style>